import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { handleNavbarType } from '../../store/layout';

export const useNavbarType = () => {
  // ** Hooks
  const dispatch = useDispatch();
  const store = useSelector((state) => state.layout);

  const setNavbarType = useCallback((type) => {
    dispatch(handleNavbarType(type));
  }, [dispatch]);

  return { navbarType: store.navbarType, setNavbarType };
};
